import { render, staticRenderFns } from "./ShowQy.vue?vue&type=template&id=04242a64&scoped=true&"
import script from "./ShowQy.vue?vue&type=script&lang=js&"
export * from "./ShowQy.vue?vue&type=script&lang=js&"
import style0 from "./ShowQy.vue?vue&type=style&index=0&id=04242a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04242a64",
  null
  
)

component.options.__file = "ShowQy.vue"
export default component.exports